export default "__VITE_ASSET__Bmku4GcD__"